export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-lg">
                7
              </span>
              <span className="text-xl font-bold text-background-50 font-heading">
                7777影院
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              7777影院致力于为广大影迷提供免费高清电影、电视剧大全在线观看服务。每日更新最新影视资源，全网CDN极速秒播，播放流畅不缓冲，是您追剧观影的首选平台。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">
              快速导航
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: '热门专题', href: '#carousel' },
                { label: '平台优势', href: '#features' },
                { label: '影视索引', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">
              内容分类
            </h3>
            <ul className="space-y-2.5">
              {['最新电影', '电视剧大全', '热门综艺', '动漫番剧', '纪录片', '高分推荐'].map((item) => (
                <li key={item}>
                  <span className="text-sm text-background-400">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 uppercase tracking-wider">
              合作伙伴
            </h3>
            <p className="text-sm text-background-500 leading-relaxed">
              诚邀优质内容合作伙伴加入，共同打造高品质影视观看体验。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 7777影院 - 777777影院免费电影高清在线观看 | 电视剧大全不缓冲全集
          </p>
          <p className="text-xs text-background-500">
            本站所有资源均来自网络，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}